<template>
  <div class="container">
    <div class="container-top">
      <img :src="this.publicData.serverUrl + 'images/banenr@2x.png'" alt="" />
    </div>
    <div class="main">
      <div class="main-content">
        <div class="side">
          <div
            class="side-item"
            :class="{ 'is-active': side.id === active }"
            v-for="side in sides"
            :key="side.id"
            @click="handleSide(side)"
          >
            {{ $t(side.title) }}
          </div>
        </div>
        <div class="header">
          <div class="header-title" v-if="!showContent">
            <!-- <img :src="icon" alt="" /> -->
            <p>{{ current }}</p>
          </div>
          <div class="header-title" @click="handleChange" v-else>
            <i class="el-icon-arrow-left"></i>
            <p>{{ $t('lang.external.zxgk.返回') }}</p>
          </div>
          <div class="header-position">
            <span>
              {{ $t('lang.external.zxgk.您当前的位置:平台首页>中心概况>') }}
              {{ current }}
            </span>
            <span v-if="showContent">
              > {{ $t('lang.external.zxgk.正文') }}</span
            >
          </div>
        </div>
        <Intro-content
          :list="articleList"
          :show="showContent"
          :content="articleContent"
          @change="handleChange"
          v-if="articleList.length !== 1"
        />
        <div class="content" v-else>
          <div v-html="articleContentBody"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatLan } from '@/utils/lanFormat'
import { menuList, articles, articleInfo } from '@/api/introduction/index'
import IntroContent from '@/components/introduction/intro-content.vue'
export default {
  name: 'Introduction',
  components: { IntroContent },
  props: [],
  data() {
    return {
      articleContentBody: '',
      current: 'lang.external.zxgk.中心简介',
      icon: this.publicData.serverUrl + 'images/icon@2x.png',
      sides: [
        {
          id: 0,
          title: 'lang.external.zxgk.中心简介',
          icon: this.publicData.serverUrl + 'images/icon@2x.png',
        },
        {
          id: 1,
          title: 'lang.external.zxgk.组织机构',
          icon: this.publicData.serverUrl + 'images/组织结构@2x.png',
        },
        {
          id: 2,
          title: 'lang.external.zxgk.发展历程',
          icon: this.publicData.serverUrl + 'images/icon@2x.png',
        },
        {
          id: 3,
          title: 'lang.external.zxgk.规章制度',
          icon: this.publicData.serverUrl + 'images/规章@2x.png',
        },
        {
          id: 4,
          title: 'lang.external.zxgk.建设成果',
          icon: this.publicData.serverUrl + 'images/icon@2x.png',
        },
      ],
      active: 0,
      showContent: false,
      articleList: [],
      articleContent: {},
    }
  },
  watch: {
    menus() {
      this.initSide()
    },
    id() {
      this.initSide()
    },
  },
  computed: {
    ...mapState(['menus']),
    id() {
      return this.$route.query.id
    },
    aid() {
      return this.$route.query.aid
    },
  },
  created() {},
  mounted() {
    this.initSide()
  },
  methods: {
    handleSide(v) {
      this.active = v.id
      this.current = v.title
      this.icon = v.icon
      this.showContent = false
      this.getArticles(v.id)
    },
    handleChange() {
      this.showContent = !this.showContent
    },
    initSide() {
      let id = parseInt(this.id)
      let menu_id = null
      this.menus.forEach((v, index) => {
        if (index > 0) {
          if (v.id === 8 || v.id === 9) {
            v.child.forEach((item) => {
              if (typeof item.title === 'object') {
                item.title = formatLan(item.title)
              }
            })
          }
        }

        if (v.id === id) {
          this.sides = v.child
          this.current = v.title
          menu_id = v.id
          if (v.child.length) {
            this.current = v.child[0].title
            this.active = v.child[0].id
            menu_id = v.child[0].id
          }
          this.getArticles(menu_id)
        }
      })
    },
    async getArticles(id) {
      await articles({ menu_id: id }).then((res) => {
        const { data } = res.data
        if (data.length > 0) {
          data.forEach((v) => {
            if (typeof v.title === 'object') {
              v.title = formatLan(v.title)
            }
            if (typeof v.body === 'object') {
              this.articleContent = formatLan(v.body)
            }
          })
        }
        this.articleList = data
        this.showContent = false
        if (this.aid) {
          let articleContent = data.filter(
            ({ id }) => id === parseInt(this.aid)
          )
          this.articleContent = articleContent[0]
          this.showContent = true
          return
        }
        if (data.length === 1) this.getArticleInfo(data[0].id)
      })
    },
    getArticleInfo(id) {
      articleInfo(id).then((res) => {
        const { data } = res
        this.articleContent = data
        if (data.body != null && typeof data.body === 'object') {
          this.articleContentBody = formatLan(data.body)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  color: #666666;
  &-top {
    height: 40vh;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .main {
    width: 100%;
    padding: 20px 18.8%;
    &-content {
      width: 100%;
      background: #ffffff;
      border-radius: 5px;
      position: relative;
      .side {
        position: absolute;
        left: -6.66666vw;
        top: 0;
        width: 6.66666vw;
        &-item {
          text-align: center;
          margin: 2.3148vh 0;
          line-height: 1.5;
          cursor: pointer;
          user-select: none;
        }
        .is-active {
          color: #0c5893;
          font-weight: bold;
          border-left: 3px solid #0c5893;
        }
      }
      .header {
        width: 100%;
        padding: 0 1.3vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #d7d7d7;
        &-title {
          display: flex;
          align-items: center;
          p,
          i {
            color: #0c5893;
            font-weight: bold;
          }
          img {
            width: 1.40625vw;
            margin-right: 10px;
          }
          i {
            margin-right: 10px;
            cursor: pointer;
          }
        }
        &-position {
          color: #999999;
          font-size: 0.83333333vw;
        }
      }
      .content {
        width: 100%;
        min-height: 45vh;
        padding: 3.703vh 3.125vw;
        div {
          color: #777777;
          font-size: 0.8333vw;
          line-height: 1.75;
          text-indent: 2rem;
          overflow: hidden;
        }
      }
    }
  }
}
</style>